// src/locales/violations-en.ts

export default {
  violations: {
    // Dashboard
    dashboard: {
      title: "Violation Overview",
      subtitle: "Monitor and manage copyright violation reports",
      totalReports: "Total Reports",
      pendingReports: "Pending", 
      resolvedReports: "Resolved",
      rejectedReports: "Rejected",
      successRate: "Success Rate",
      avgResolutionTime: "Avg Resolution Time",
      platformBreakdown: "Platform Breakdown",
      violationTypeBreakdown: "Violation Type Breakdown",
      trends: "Report Trends",
      recentReports: "Recent Reports"
    },

    // Form
    form: {
      title: "Report Copyright Violation",
      subtitle: "Report copyright infringement to protect your intellectual property",
      selectWork: "Select violated work",
      reportWorkPlaceholder: "Enter the name of the violated Work...",
      workPlaceholder: "Search your works...",
      violationType: "Violation type",
      selectViolationType: "Select violation type",
      violationUrl: "Violation URL",
      platform: "Platform",
      description: "Detailed Description",
      descriptionPlaceholder: "Detailed description of the violation, time of detection, and impact…",
      autoDetected: "Automatic detection",
      evidenceFiles: "Evidence Files",
      declaration: "I confirm the information above is accurate",
      submit: "Submit Report",
      submitting: "Submitting...",
      cancel: "Cancel",
      next: "Next",
      previous: "Previous",
      
      // Steps
      steps: {
        name: "Step ${step}",
        selectWork: "Select Work",
        violationInfo: "Violation Info", 
        evidence: "Evidence",
        confirmation: "Confirmation"
      },

      // Validation
      validation: {
        workRequired: "Please select a violated work",
        violationTypeRequired: "Please select violation type",
        urlRequired: "Please enter violation URL",
        urlInvalid: "Invalid URL",
        descriptionRequired: "Please describe the violation",
        descriptionMinLength: "Description must be at least 20 characters",
        declarationRequired: "Please confirm the accuracy of information"
      },

      // Success messages
      success: {
        submitted: "Violation report submitted successfully!",
        updated: "Report has been updated",
        deleted: "Report has been deleted"
      },

      fileUpload: {
        dragDrop: "Drag and drop file or click to select",
        support: "Supported formats: {{ extensionsSupport }} (maximum {{ maxSizeSupport }} per file)",
        fileSelected: "Selected file ({{ count }})",
      },

      evidenceNote: "Notice",
      evidenceDescription: "The more detailed and clear the evidence, the faster and more effective the report handling will be.",
      
      reminderText: "Important",
      reminderSubText: "Please double-check the information before submitting the report.",

      verifyInformation: {
        workLabel: "Work information",
        name: "Name",
        type: "Type",
        category: "Category",
        violationLabel: "Violation information",
        platformLabel: "Platform",
        descriptionLabel: "Violation description",
        evidenceLabel: "Evidence",
        evidenceText: "{{count}} file(s) uploaded",
        confirmText: "I confirm that all the above information is accurate and that I have the legal ownership rights to the infringed work. I understand that providing false information may result in legal consequences.",
        identityProtection: "Identity protection and the ability to report anonymously"
      }
    },

    // Search functionality
    search: {
      searchWorks: "Search works...",
      searchPlaceholder: "Search reports, works, URLs...",
      noWorksFound: "No works found",
      searchHint: "Enter at least 2 characters to search",
      selectWork: "Select work from list",
      selectedWork: "Selected work"
    },

    // Severity
    severity: {
      low: "Low",
      medium: "Medium", 
      high: "High",
      critical: "Critical"
    },

    // Platforms
    platforms: {
      facebook: "Facebook",
      instagram: "Instagram",
      youtube: "YouTube",
      tiktok: "TikTok", 
      twitter: "Twitter/X",
      linkedin: "LinkedIn",
      website: "Website",
      other: "Other"
    },

    // Table headers
    table: {
      id: "ID",
      work: "Work",
      violationType: "Violation Type",
      platform: "Platform", 
      url: "Violation URL",
      reportDate: "Report Date",
      status: "Status",
      severity: "Severity",
      evidence: "Evidence",
      actions: "Actions",
      violator: "Violator",
      detectionTime: "Detection Time",
      owner: "Owner"
    },

    // Actions
    actions: {
      view: "View",
      edit: "Edit",
      delete: "Delete",
      report: "Report",
      confirm: "Confirm",
      reject: "Reject",
      legalAction: "Legal Action",
      dismiss: "Dismiss",
      refresh: "Refresh",
      export: "Export",
      filter: "Filter",
      search: "Search",
      sort: "Sort"
    },

    // Filters
    filters: {
      allStatuses: "All Statuses",
      allTypes: "All Violation Types",
      allPlatforms: "All Platforms",
      allSeverities: "All Severities",
      clearFilters: "Clear Filters",
      appliedFilters: "Applied Filters"
    },

    // Modal content
    modal: {
      title: "Violation report details #{{id}}",
      violationId: "Violation report ID",
      violatedWork: "Work Subject to violation",
      owner: "Owner",
      platform: "Platform",
      violationType: "Violation Type",
      severity: "Violation severity",
      detectionTime: "Detection Time",
      violationUrl: "Violation URL",
      violator: "Violator",
      evidence: "Evidence",
      actions: "Actions Taken",
      noActionsRecorded: "No actions recorded yet",
      close: "Close",

      // Delete confirmation
      deleteTitle: "Confirm Report Deletion",
      deleteMessage: "Are you sure you want to delete this report?",
      deleteWarning: "This action cannot be undone",
      deleteNote: "Reports can only be deleted when in 'Processing' status"
    },

    // Messages
    messages: {
      noViolationsFound: "No violations found",
      noReports: "You haven't submitted any violation reports yet",
      createFirstReport: "Create your first report",
      loadingReports: "Loading reports...",
      loadingError: "Error occurred while loading data",
      tryAgain: "Try Again",
      contactSupport: "Contact Support",
      needHelp: "Need Help?",
      helpDescription: "If you're having trouble reporting violations or need legal advice"
    },
  },

  // violations details translations
  violationDetails: {
    title: "Thông tin chi tiết vi phạm",
    tabs: {
      overview: "Tổng quan",
      evidence: "Bằng chứng",
      complaints: "Phản ứng"
    },
    downloadReport: "Tải vi phạm",
    violationInfo: "Thông tin vi phạm",
    detectedDate: "Ngày báo cáo",
    description: "Mô tả vi phạm",
    complaints: "Danh sách khiếu nại ({{count}})",
    createComplaint: "Thêm khiếu nại",
    noComplaints: "Không có khiếu nại nào",
    contentInfo: "Thông tin Tác phẩm",
    contentTitle: "Tiêu đề Tác phẩm",
    unknownContent: "Chưa xác định",
    contentId: "Mã Tác phẩm",
    contentOwner: "Thông tin Tác giả",
    actionsHistory: "Nhật ký",
    systemInfo: "Thông tin hệ thống",
    createdAt: "Ngày báo cáo",
    updatedAt: "Ngày cập nhật",
    appCreatedBy: "Người báo cáo",
    processMetadata: "Nhật ký xử lý vi phạm",
    technicalSummary: 'Tóm tắt',
    
  },

  // violations common translations
  violationCommon: {
    violationStatus: "Violation status",
    types: {
      codeCopyrightInfringement: "Copyright infringement",
      codeTrademarkViolation: "Trademark violation",
      codeUnauthorizedUsage: "Unauthorized usage",
      codePlagiarism: "Plagiarism",
      codeDeepfake: "Deepfake/AI Impersonation",
      codeContentTheft: "Content theft",
      codeLicenseViolation: "License violation",
      codeImpersonation: "Impersonation",
      codeContractViolation: "Contract violation",
      codeOther: "Other"
    },

    status: {
      codeDetected: "Detected",
      codeVerified: "Verified",
      codeNotified: "Notified",
      codeAcknowledged: "Acknowledged",
      codeContentRemoved: "Content Removed",
      codeContentModified: "Content Modified",
      codeDisputeFiled: "Dispute Filed",
      codeUnderReview: "Under Review",
      codeResolved: "Resolved",
      codeDismissed: "Dismissed",
      codeLegalAction: "Legal Action",
      codeEscalated: "Escalated",
      codeExpired: "Expired"
    },

    severities: {
      codeLow: "Low",
      codeMedium: "Medium",
      codeHigh: "High",
    }

  },

  // AI Scan specific translations
  aiScan: {
    // AI Scan English translations
    // (Similar structure to Vietnamese)
  }
};